var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',_vm._l((_vm.data),function(el,i){return _c('b-col',{key:`procedures-data-${i}`},[_vm._v(" "+_vm._s(el.code)+" "+_vm._s(el.text)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }